import * as React from 'react';
import * as ViewManagementModule from 'Modules/ViewManagementModule';
import {ActionDetailsIcon} from 'HelperFunctions/DetailsSidebarHelpers';
import * as UserModule from "Modules/UserModule";

export enum ParentDetailsTypeEnum {
    SIDEBAR_LIST = 'SIDEBAR_LIST',
    SIDEBAR_ONE_ELEMENT = 'SIDEBAR_ONE_ELEMENT'
}

interface IParentDetailsState {
}

export interface IParentDetailsProps {
    history: any;
    showPopup: (popupData: ViewManagementModule.Types.Popup) => Function;
    t?: (key: string) => string;
    user?: UserModule.Types.UserDto;
}

export type CustomProps = {
    setActiveEl: (el?: any) => any;
    deleteEl?: (id?: number) => any;
    elStore?: any;
    activeEl: any;
    redirectUrlEdit?: string;
    redirectUrlAdd?: string;
    redirectUrlList?: string;
    popupTypeDelete?: string;
    labelAdd?: string;
    labelEdit?: string;
    labelDelete?: string;
    t?: any;
    showPopup?: any;
    [name: string]: any;
    extrnalRender?: Function;
    type: ParentDetailsTypeEnum;
};

interface IParentDetails {
    getCustomProps: () => CustomProps;
}

export abstract class ParentDetails<P extends IParentDetailsProps, S extends IParentDetailsState> extends React.Component<P, S> implements IParentDetails {
    constructor(props: P) {
        super(props);
    }

    protected manageAddClick() {
        if (this.addButtonIsDisabled()) {
          return
        }
        const {setActiveEl, redirectUrlAdd} = this.getCustomProps();
        setActiveEl(null);
        this.props.history.push(redirectUrlAdd);
    }

    protected manageEditClick() {
        const {redirectUrlEdit, setActiveEl} = this.getCustomProps();
        if (!this.editButtonIsDisabled()) {
            setActiveEl(null);
            this.props.history.push(redirectUrlEdit);
        }
    }

    protected manageDeleteClick() {
        const {activeEl, showPopup, deleteEl, setActiveEl, popupTypeDelete} = this.getCustomProps();
        const {PopupType} = ViewManagementModule.VMEnumTypes;
        if (!this.deleteButtonIsDisabled()) {
            showPopup({
                type: popupTypeDelete || PopupType.DELETE_ALERT,
                confirmCallback: async () => {
                    await deleteEl(activeEl.id);
                    setActiveEl(null);
                }
            });
        }
    }

    public getCustomProps(): CustomProps {
        console.error('Not yet implemented IParentDetails');
        return {
            ...(this.props as any),
            setActiveEl: (el?: any) => {
                //gg
            },
            deleteEl: (id?: number) => {
                //gg
            },
            redirectUrlEdit: '',
            redirectUrlAdd: '',
            popupTypeDelete: ''
        };
    }

    protected sendForm() {
        //gg
    }

    protected cancelClick() {
        const props = this.getCustomProps();
        this.props.history.push(props.redirectUrlList);
    }

    protected addButtonIsDisabled(): boolean {
        return this.isExternalUser();
    }

    protected editButtonIsDisabled(): boolean {
      if (this.isExternalUser()) {
        return true;
      }

        const {activeEl} = this.getCustomProps();
        return !activeEl;
    }

    protected deleteButtonIsDisabled(): boolean {
        const {activeEl} = this.getCustomProps();
        return !activeEl;
    }

    protected buttonIsDisabled(): boolean {
        const {activeEl} = this.getCustomProps();
        return !activeEl;
    }

    public render() {
        const {t, labelAdd, labelEdit, labelDelete, extrnalRender, type} = this.getCustomProps();

        const classNameAddBtn = this.addButtonIsDisabled() ? '  details-right__dashboard-item--disabled  ' : '';
        const classNameEditBtn = this.editButtonIsDisabled() ? '  details-right__dashboard-item--disabled  ' : '';
        const classNameDeleteBtn = this.deleteButtonIsDisabled() ? '  details-right__dashboard-item--disabled  ' : '';

        return (
            <div className="details-right__dashboard">
                {type == ParentDetailsTypeEnum.SIDEBAR_ONE_ELEMENT ? (
                    <>
                        <ActionDetailsIcon active iconSrc={`/images/icons/save.svg`} title={t('forms:save')}
                                           e2eId={"saveBtn"} onClick={() => this.sendForm()}/>

                        <ActionDetailsIcon active iconSrc={`/images/icons/red_cros.svg`} title={t('forms:cancel')}
                                           e2eId={"cancelBtn"} onClick={() => this.cancelClick()}/>
                    </>
                ) : (
                    <>
                        {labelAdd != undefined && (
                            <div className={`details-right__dashboard-item ${classNameAddBtn}`} date-e2eid="createBtn"
                                 onClick={() => this.manageAddClick()}>
                                <i className="details-right__dashboard-icon icon--plus_sign icon--plus_sign_big"/>
                                <span>{labelAdd}</span>
                            </div>
                        )}

                        {labelEdit != undefined && (
                            <div className={`details-right__dashboard-item ${classNameEditBtn}`} date-e2eid="editBtn"
                                 onClick={() => this.manageEditClick()}>
                                <img src={`/images/icons/edit-sign.svg`} alt=""
                                     className="details-right__dashboard-icon"/> <span>{t(labelEdit)}</span>
                            </div>
                        )}

                        {labelDelete != undefined && (
                            <div className={`details-right__dashboard-item ${classNameDeleteBtn}`}
                                 date-e2eid="deleteBtn" onClick={() => this.manageDeleteClick()}>
                                <img src={`/images/icons/garbage.svg`} alt=""
                                     className="details-right__dashboard-icon"/> <span>{t(labelDelete)}</span>
                            </div>
                        )}
                    </>
                )}

                {extrnalRender && extrnalRender()}
            </div>
        );
    }

  public isExternalUser() {
    return this.props.user?.roleName === UserModule.UserEnumTypes.RoleName.EXTERNAL
  }
}



// WEBPACK FOOTER //
// ./src/components/Layout/DetailsSidebar/ParentDetails.tsx